import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';

import { Camera, CameraOptions } from '@ionic-native/camera';

/**
 * Generated class for the WallAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-wall-add',
  templateUrl: 'wall-add.html',
})
export class WallAddPage {

  type: string = '';

  image_data: any = '';
  base64img: any = '';

  content: any = '';
  attribute: any = '';
  constructor(public navCtrl: NavController, public camera: Camera, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WallAddPage');
  }

  chooseType(type: string) {
    this.type=type;
  }

  chooseColor(color: string) {
    if(color == this.attribute) {
      this.attribute = '';
    } else {
      this.attribute = color;
    }
  }

  imageCaptured() {
    const options:CameraOptions={
      quality:70,
      destinationType:this.camera.DestinationType.DATA_URL,
      sourceType:this.camera.PictureSourceType.PHOTOLIBRARY,
      saveToPhotoAlbum:false
    }
    this.camera.getPicture(options).then((ImageData=>{
      this.base64img=ImageData;
      this.image_data = this.base64img;
    }),error=>{
      console.log(error);
    })
  }

  publish() {

    this.teamappProvider.http_request('action=add_item&type='+this.type+'&image='+this.image_data+'&text='+this.content+'&attribute='+this.attribute, 'wall', false, true).then(data => {
      console.log(data);
      this.navCtrl.pop();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/wall-add/wall-add.ts